import { render, staticRenderFns } from "./EfficiencyMessengerBot.vue?vue&type=template&id=2a73e82a&scoped=true&"
import script from "./EfficiencyMessengerBot.vue?vue&type=script&lang=js&"
export * from "./EfficiencyMessengerBot.vue?vue&type=script&lang=js&"
import style0 from "./EfficiencyMessengerBot.vue?vue&type=style&index=0&id=2a73e82a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a73e82a",
  null
  
)

export default component.exports